document.documentElement.classList.add('colorgrid-booting');
/* =========================================================
   Color Grid (Boost) - color-grid template only (STABLE)
   Goal: prevent reverting to featured image
   - No grid.innerHTML
   - Expand base cells into variant cells
   - Protect img/src from being overwritten
========================================================= */

console.warn('[colorGrid] LOADED stable v2026-02-02-A');

(function waitFlag() {
  if (!document.querySelector('[data-enable-color-grid="true"]')) {
    setTimeout(waitFlag, 60);
    return;
  }
  if (window.__colorGridBooted) return;
  window.__colorGridBooted = true;
  document.documentElement.classList.add('colorgrid-booting');
  console.warn('[colorGrid] boot flag OK');

  // -------------------------------------------------------
  // 1) Selectors / constants
  // -------------------------------------------------------
  const GRID_SELECTOR = '.boost-pfs-filter-products';
  const CELL_SELECTORS = [
    ':scope > .Grid__Cell',
    ':scope > .ProductList__Item',
    ':scope > .boost-pfs-filter-product-item'
  ].join(',');


  const LINK_SELECTOR = 'a[href*="/products/"]';

  const COLOR_KEYWORDS = [
    'color','カラー','カラー名','色','色味','colour','couleur','colore','farbe','col','clr'
  ];

  const __productCache = new Map();
  window.__colorGridRunning = false;
  window.__colorGridMutating = false;

  // -------------------------------------------------------
  // 2) Helpers
  // -------------------------------------------------------
  function uniq(a){ return Array.from(new Set(a)); }

  function findGrid(){
    return (
      document.querySelector('.boost-pfs-filter-products') ||
      document.querySelector('#boost-pfs-filter-products') ||
      document.querySelector('.boost-pfs-filter-product-list') ||
      document.querySelector('.ProductList')
    );
  }

  function getHandleFromHref(href) {
    const m = (href || '').match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : null;
  }

  function getHandleFromCell(cell) {
    const a = cell.querySelector(LINK_SELECTOR);
    if (!a) return null;
    return getHandleFromHref(a.getAttribute('href') || '');
  }

 function normalizeShopifyImgUrl(url) {
  if (!url) return '';
  let u = String(url).trim();

  if (u.startsWith('//')) u = 'https:' + u;
  if (u.startsWith('cdn.shopify.com')) u = 'https://' + u;

  // Shopifyのサイズ指定を幅広く除去
  u = u.replace(/_((\d+x\d*)|(\d+x)|(\d+)|({width}x))(?=\.(jpg|jpeg|png|webp)(\?|$))/i, '');

  return u;
}

  async function fetchProductJson(handle) {
    if (__productCache.has(handle)) return __productCache.get(handle);

    const p = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then(res => {
        if (!res.ok) throw new Error('fetch failed: ' + handle);
        return res.json();
      });

    __productCache.set(handle, p);
    return p;
  }

  function getColorOptionIndex(p) {
    if (!Array.isArray(p.options)) return -1;
    const names = p.options.map(x => String(x).toLowerCase());
    const idx = names.findIndex(n => COLOR_KEYWORDS.some(k => n.includes(k)));
    return idx !== -1 ? idx : 0;
  }

  function getOpt(v, idx) {
    if (Array.isArray(v.options) && v.options[idx] != null) return v.options[idx];
    const key = 'option' + (idx + 1);
    return v[key] ?? null;
  }

  function getImgFromVariant(v, fallback) {
    if (v?.featured_image) {
      if (typeof v.featured_image === 'string') return v.featured_image;
      if (v.featured_image.src) return v.featured_image.src;
    }
    if (v?.image) {
      if (typeof v.image === 'string') return v.image;
      if (v.image.src) return v.image.src;
    }
    return fallback || '';
  }

  // -------------------------------------------------------
  // 3) Protect image from being overwritten
  // -------------------------------------------------------
  function setImgEverywhere(img, url) {
    url = normalizeShopifyImgUrl(url);
    if (!url) return;

    // Many themes use data-src / data-srcset
    img.setAttribute('src', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.loading = 'eager';
    img.decoding = 'async';

    // If <picture> exists, kill <source> that can override
    const pic = img.closest('picture');
    if (pic) {
      pic.querySelectorAll('source').forEach(s => s.remove());
    }
  }

  function protectImg(img, desiredUrl) {
    desiredUrl = normalizeShopifyImgUrl(desiredUrl);
    if (!img || !desiredUrl) return;

    // store desired
    img.setAttribute('data-colorgrid-desired', desiredUrl);

    // === colorGrid lock (prevent theme override) ===
    img.src = desiredUrl;

    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('sizes');

    img.setAttribute('data-colorgrid-fixed', '1');

    //try {
    //  Object.defineProperty(img, 'src', {
    //    writable: false,
    //    configurable: false
    //  });
    //} catch(e){}


    // apply now
    setImgEverywhere(img, desiredUrl);

    // already protected?
    if (img.__colorGridProtected) return;
    img.__colorGridProtected = true;

    const obs = new MutationObserver(() => {
      const want = img.getAttribute('data-colorgrid-desired') || '';
      if (!want) return;

      const cur = (img.getAttribute('src') || '').split('?')[0];
      const w0  = want.split('?')[0];

      // If reverted, force back
      if (cur && w0 && cur !== w0) {
        setImgEverywhere(img, want);
      }
    });

    obs.observe(img, { attributes: true, attributeFilter: ['src','srcset','data-src','data-srcset','sizes'] });
    img.__colorGridObs = obs;
  }

  // -------------------------------------------------------
  // 4) Patch a cell to variant image + variant link
  // -------------------------------------------------------
 function patchCell(cell, variantId, imgUrl) {
  imgUrl = normalizeShopifyImgUrl(imgUrl);
  if (!imgUrl || !variantId) return;

  // links -> ?variant=
  cell.querySelectorAll(LINK_SELECTOR).forEach(a => {
    const base = (a.getAttribute('href') || '').split('?')[0];
    a.setAttribute('href', base + '?variant=' + variantId);
  });

  const pickImg = () =>
    cell.querySelector('img.ProductItem__Image:not(.ProductItem__Image--alternate)') ||
    cell.querySelector('a.ProductItem__ImageWrapper img') ||
    cell.querySelector('.ProductItem__ImageWrapper img') ||
    cell.querySelector('img');

  let img = pickImg();
  if (!img) return;

  // protect
  protectImg(img, imgUrl);

  // remove loader
  const loader = cell.querySelector('.Image__Loader,.image__loader,.product__loader');
  if (loader) loader.remove();

  // ★超重要：テーマ/Boostが img を作り直したら再度 protect する
  if (!cell.__colorGridCellObs) {
    const obs = new MutationObserver(() => {
      const newImg = pickImg();
      if (!newImg) return;
      // もし新しいimgに desired が無ければ、今のimgUrlで再保護
      const desired = newImg.getAttribute('data-colorgrid-desired') || imgUrl;
      protectImg(newImg, desired);
    });
    obs.observe(cell, { childList: true, subtree: true });
    cell.__colorGridCellObs = obs;
  }
}


  // -------------------------------------------------------
  // 5) Rebuild (NO grid.innerHTML)
  // -------------------------------------------------------
  async function rebuild(reason) {
    if (window.__colorGridRunning) return;
    window.__colorGridRunning = true;

    const grid = findGrid();
    if (!grid) { window.__colorGridRunning = false; return; }

    try {
      const allCells = Array.from(grid.querySelectorAll(CELL_SELECTORS));
      if (!allCells.length) return;

      // base = not expanded
      const baseCells = allCells.filter(c => !c.hasAttribute('data-color-expanded'));

      console.warn('[colorGrid] rebuild', reason || '', 'cells=', allCells.length, 'base=', baseCells.length);

      // If no base cells: just re-protect expanded images
      if (!baseCells.length) {
        const expanded = Array.from(grid.querySelectorAll('[data-color-expanded="1"]'));
        if (!expanded.length) return;

        const handles = uniq(expanded.map(c => c.getAttribute('data-product-handle')).filter(Boolean));
        if (!handles.length) return;

        const settled = await Promise.allSettled(handles.map(fetchProductJson));
        const products = settled.filter(r => r.status === 'fulfilled').map(r => r.value);
        if (!products.length) return;

        // repatch + protect again
        for (const cell of expanded) {
          const h = cell.getAttribute('data-product-handle');
          const vid = Number(cell.getAttribute('data-variant-id'));
          if (!h || !vid) continue;
          const p = products.find(x => x.handle === h);
          if (!p) continue;
          const v = (p.variants || []).find(x => x.id === vid);
          if (!v) continue;
          patchCell(cell, vid, getImgFromVariant(v, p.featured_image));
        }
        return;
      }

      // fetch products for base cells
      const handles = baseCells.map(getHandleFromCell).filter(Boolean);
      const uniqueHandles = uniq(handles);
      if (!uniqueHandles.length) return;

      const settled = await Promise.allSettled(uniqueHandles.map(fetchProductJson));
      const products = settled.filter(r => r.status === 'fulfilled').map(r => r.value);
      if (!products.length) return;

      // group base cells by handle
      const byHandle = new Map();
      for (const c of baseCells) {
        const h = getHandleFromCell(c);
        if (!h) continue;
        if (!byHandle.has(h)) byHandle.set(h, []);
        byHandle.get(h).push(c);
      }

      window.__colorGridMutating = true;
      try {
        for (const [handle, cellsOfHandle] of byHandle.entries()) {
          const p = products.find(x => x.handle === handle);
          if (!p) continue;

          const colorIdx = getColorOptionIndex(p);
          if (colorIdx === -1) continue;

          // available colors only
          const colors = uniq(
            (p.variants || [])
              .filter(v => v.available)
              .map(v => getOpt(v, colorIdx))
              .filter(Boolean)
          );

          if (!colors.length) continue;

          const templateCell =
          cellsOfHandle.find(c => c.querySelectorAll('.ProductItem').length <= 1) ||
          cellsOfHandle[0];

          if (!templateCell || !templateCell.isConnected) continue;

          const groupId = handle + '-' + Date.now();
          const frag = document.createDocumentFragment();

          for (const colorName of colors) {
            const v = (p.variants || []).find(x => x.available && getOpt(x, colorIdx) === colorName);
            if (!v) continue;

            const clone = templateCell.cloneNode(true);

            // --- 重要：clone内に ProductItem が複数ある場合は 1個だけ残す（縦積み崩れ防止） ---
            const items = Array.from(clone.querySelectorAll('.ProductItem'));
            if (items.length > 1) {
              for (let k = 1; k < items.length; k++) items[k].remove();
            }

            // --- 重要：既存の展開属性が子孫に残ってたら除去（次のrebuildでtemplate汚染を防ぐ） ---
            clone.querySelectorAll('[data-color-expanded],[data-color-expanded-group],[data-product-handle],[data-variant-id]').forEach(el => {
              el.removeAttribute('data-color-expanded');
              el.removeAttribute('data-color-expanded-group');
              el.removeAttribute('data-product-handle');
              el.removeAttribute('data-variant-id');
            });

            // --- この clone 自体に正しい属性を付与 ---
            clone.setAttribute('data-color-expanded', '1');
            clone.setAttribute('data-color-expanded-group', groupId);
            clone.setAttribute('data-product-handle', handle);
            clone.setAttribute('data-variant-id', String(v.id));

            // ✅ 位置崩れの原因になりやすい inline style を消す（あなたの方針でOK）
            /*clone.removeAttribute('style');*/

            // 先に画像＆リンク差し替え
            patchCell(clone, v.id, getImgFromVariant(v, p.featured_image));

            frag.appendChild(clone);

          }

          if (frag.childNodes.length) {
            templateCell.replaceWith(frag);
            // remove duplicate base cells of same handle
            for (let i = 1; i < cellsOfHandle.length; i++) {
              try { cellsOfHandle[i].remove(); } catch(e) {}
            }
            markColorGridReady();
          }
        }
      } finally {
        setTimeout(() => { window.__colorGridMutating = false; }, 0);
      }

      // ★ lazy対策：後から代表画像へ戻されるのを上書きで取り返す
      [200, 700, 1400, 2200].forEach(ms => {
        setTimeout(() => {
          try { repatchExpandedCells(products); } catch(e) {}
        }, ms);
      });


      // re-protect once more after DOM settles
      setTimeout(() => rebuild('repatch'), 250);
      setTimeout(markColorGridReady, 350);

    } catch (e) {
      console.warn('[colorGrid] rebuild error', e);
    } finally {
        window.__colorGridRunning = false;
      }
  }


  function markColorGridReady() {
  const g = findGrid();
  if (g) g.classList.add('is-colorgrid-ready');

  document.documentElement.classList.remove('colorgrid-booting');
  document.documentElement.classList.add('colorgrid-ready');
}

  window.__colorGridManualRebuild = rebuild;

  // -------------------------------------------------------
  // 6) Hooks: follow Boost DOM changes (light)
  // -------------------------------------------------------
  function hookBoostAutoRender() {
    if (window.__colorGridAutoHooked) return;
    window.__colorGridAutoHooked = true;

    const root =
      document.querySelector('.CollectionInner__Products') ||
      document.querySelector('.ProductListWrapper') ||
      document.querySelector('.boost-pfs-filter-wrapper') ||
      document.body;

    if (!root) return;

    let t = null;
    const schedule = (why) => {
      clearTimeout(t);
      t = setTimeout(() => {
        if (!window.__colorGridMutating) rebuild(why || 'schedule');
      }, 180);
    };

    // watch grid replace / products append
    const obs = new MutationObserver(() => {
      if (window.__colorGridMutating) return;
      schedule('dom');
    });
    obs.observe(root, { childList: true, subtree: true });

    // initial
    schedule('init');
    setTimeout(() => schedule('init2'), 500);
    setTimeout(() => schedule('init3'), 1200);
  }

  // -------------------------------------------------------
  // 7) Boot
  // -------------------------------------------------------
  (function boot() {
    let booted = false;
    function tryBoot() {
      const grid = document.querySelector(GRID_SELECTOR) || findGrid();
      if (!grid) { setTimeout(tryBoot, 120); return; }
      if (booted) return;
      booted = true;
      console.warn('[colorGrid] tryBoot OK');

      hookBoostAutoRender();
      setTimeout(() => rebuild('boot'), 0);
      setTimeout(() => rebuild('boot2'), 400);
      // ★ 最終ロック
      setTimeout(forceRepatchAfterRender, 600);
      setTimeout(forceRepatchAfterRender, 1200);
      setTimeout(forceRepatchAfterRender, 2000);

    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryBoot);
    } else {
      tryBoot();
    }



  })();

  // -------------------------------------------------------
  // 8) Minimal CSS
  // -------------------------------------------------------
  (function injectCSSOnce(){
    if (document.getElementById('color-grid-css')) return;
    const style = document.createElement('style');
    style.id = 'color-grid-css';
    style.textContent =
  "html.colorgrid-booting body{opacity:0!important;}\n" +
  "html.colorgrid-ready body{opacity:1!important;transition:opacity .15s ease;}\n" +
  ".ProductItem__ImageWrapper .AspectRatio{aspect-ratio:5/6;padding-bottom:0!important;}\n";
    document.head.appendChild(style);
  })();


  function repatchExpandedCells(products) {
  const grid = findGrid();
  if (!grid) return;

  const expanded = Array.from(grid.querySelectorAll('[data-color-expanded="1"]'));
  console.warn('[colorGrid] repatchExpandedCells', expanded.length);

  for (const cell of expanded) {
    const handle = cell.getAttribute('data-product-handle');
    const vid = Number(cell.getAttribute('data-variant-id'));
    if (!handle || !vid) continue;

    const p = products.find(x => x.handle === handle);
    if (!p) continue;

    const v = (p.variants || []).find(x => x.id === vid);
    if (!v) continue;

    patchCell(cell, vid, getImgFromVariant(v, p.featured_image));
  }
}


  // =======================================
// FINAL SAFETY PATCH (after Boost render)
// =======================================
function forceRepatchAfterRender() {
  const grid = findGrid();
  if (!grid) return;

  const imgs = grid.querySelectorAll('img');

  imgs.forEach(img => {
    const desired = img.getAttribute('data-colorgrid-desired');
    if (!desired) return;

    const cur = normalizeShopifyImgUrl(img.getAttribute('src') || img.src);
    const want = normalizeShopifyImgUrl(desired);

    if (cur.split('?')[0] !== want.split('?')[0]) {
      console.warn('[colorGrid] force repatch', want);
      setImgEverywhere(img, want);
    }
  });
}


})();
